//Importación de librerias
//---------------sinoj---------------
//Comunes
import FiltrosDeBusqueda from '../../../src/components/SINOJ/Comun/FiltrosDeBusqueda.vue'
import CDescripcionBasicaDeCedula from '../../../src/components/SINOJ/Comun/CDescripcionBasicaDeCedula.vue'
import CTablaGenericaCedulas from '../../../src/components/SINOJ/Comun/CTablaGenericaCedulas.vue'
import CEditorTexto from '../../../src/components/SINOJ/Comun/CEditorTexto.vue'
import CInformacionBasicaDeCedula from '../../../src/components/SINOJ/Comun/CInfomacionBasicoDeCedula.vue'
import CMapaDeDomicilios from '../../../src/components/SINOJ/Comun/CMapaDeDomicilios.vue'
import CFormularioRegistroEmpresa from '../../../src/components/SINOJ/Comun/CFormularioRegistroEmpresa.vue'
import CMapaDePoligonos from '../../../src/components/SINOJ/Comun/CMapaDePoligonos.vue'
import CCatalogoGenerico from '../../../src/components/SINOJ/Comun/CCatalogoGenerico.vue'
import CFormularioDomicilio from '../../../src/components/SINOJ/Comun/CFormularioDomicilio.vue'
import CFormularioRepresentantesLegales from '../../../src/components/SINOJ/Comun/CFormularioRepresentantesLegales.vue'
import CFormularioRegistroPersonaMoral from '../../../src/components/SINOJ/Cedulas/Creacion/CFormularioPersonaMoral.vue'
import CEditorDeTextoCK from '../../../src/components/SINOJ/Comun/CEditorDeTextoCK.vue'
import CSubidorDeArchivos from '../../../src/components/SINOJ/Comun/CSubidorDeArchivos.vue'
import CEleccionDePlantilla from '../../../src/components/SINOJ/Comun/CEleccionDePlantilla.vue'
import CMenuModulo from '../../../src/components/SINOJ/Comun/CMenuModulo.vue'


//Creamos y asignamos los datos necesarios de sinoj
const sinoj = [
  { Proviene: 'SINOJ', Nombre: 'FiltrosDeBusqueda', datos: FiltrosDeBusqueda },  
  { Proviene: 'SINOJ', Nombre: 'CDescripcionBasicaDeCedula', datos: CDescripcionBasicaDeCedula },
  { Proviene: 'SINOJ', Nombre: 'CTablaGenericaCedulas', datos: CTablaGenericaCedulas },
  { Proviene: 'SINOJ', Nombre: 'CEditorTexto', datos: CEditorTexto },
  { Proviene: 'SINOJ', Nombre: 'CInformacionBasicaDeCedula', datos: CInformacionBasicaDeCedula },
  { Proviene: 'SINOJ', Nombre: 'CMapaDeDomicilios', datos: CMapaDeDomicilios },
  { Proviene: 'SINOJ', Nombre: 'CFormularioRegistroEmpresa', datos: CFormularioRegistroEmpresa },
  { Proviene: 'SINOJ', Nombre: 'CMapaDePoligonos', datos: CMapaDePoligonos },
  { Proviene: 'SINOJ', Nombre: 'CCatalogoGenerico', datos: CCatalogoGenerico },
  { Proviene: 'SINOJ', Nombre: 'CFormularioDomicilio', datos: CFormularioDomicilio },
  { Proviene: 'SINOJ', Nombre: 'CFormularioRepresentantesLegales', datos: CFormularioRepresentantesLegales },
  { Proviene: 'SINOJ', Nombre: 'CFormularioRegistroPersonaMoral', datos: CFormularioRegistroPersonaMoral },
  { Proviene: 'SINOJ', Nombre: 'CEditorDeTextoCK', datos: CEditorDeTextoCK },
  { Proviene: 'SINOJ', Nombre: 'CSubidorDeArchivos', datos: CSubidorDeArchivos },
  { Proviene: 'SINOJ', Nombre: 'CEleccionDePlantilla', datos: CEleccionDePlantilla },
  { Proviene: 'SINOJ', Nombre: 'CMenuModulo', datos: CMenuModulo }  
]


//Exportamos los datos de sinoj
export default sinoj;




//////////////////
// WEBPACK FOOTER
// ./static/js/sistemas/sinoj.js
// module id = null
// module chunks = 